'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ShowMoreLink = require('./components/ShowMoreLink.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ShowMoreLink).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/show-more-link/index.js
// module id = 1056
// module chunks = 0